export const Coupon = (json: IDiscountCoupon): IDiscountCouponModel => {
	const {
		id,
		code,
		promotion,
		promotion_id,
		usage_count,
		usage_limit,
		per_customer_usage_limit,
		created_at,
		updated_at,
	} = json

	return {
		id,
		code,
		promotionId: promotion_id,
		promotion: promotion ? DiscountPromotionShared(promotion) : null,
		usageCount: usage_count,
		usageLimit: usage_limit,
		perCustomerUsageLimit: per_customer_usage_limit,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const couponToJSON = (obj: Partial<IDiscountCouponModel>): Partial<IDiscountCoupon> => {
	const { usageLimit, perCustomerUsageLimit, ...rest } = obj
	return {
		usage_limit: usageLimit ?? null,
		per_customer_usage_limit: perCustomerUsageLimit ?? null,
		...rest,
	}
}

/**
 * Payloads
 */
const DiscountCouponPayloadShared = (
	event: IFormSubmitEvent<IDiscountCouponFormData>,
): IDiscountCouponPayloadShared => {
	const { name, usageLimitPerCoupon, usageLimitPerCustomer } = event.values

	return {
		code: name,
		usage_limit: usageLimitPerCoupon ?? null,
		per_customer_usage_limit: usageLimitPerCustomer ?? null,
		expires_at: null,
	}
}

export const CouponCreatePayload = (event: IFormSubmitEvent<IDiscountCouponFormData>): IDiscountCouponCreatePayload => {
	const shared = DiscountCouponPayloadShared(event)

	return {
		...shared,
	}
}

export const CouponUpdatePayload = (event: IFormSubmitEvent<IDiscountCouponFormData>): IDiscountCouponUpdatePayload => {
	const shared = DiscountCouponPayloadShared(event)

	return {
		...shared,
	}
}
